webpackJsonp([35783957827783],{

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'row width-container center-image' },
	      _react2.default.createElement(
	        'video',
	        { autoPlay: true, muted: true, width: '100%', loop: true },
	        _react2.default.createElement('source', {
	          src: 'https://res.cloudinary.com/ditqglru2/video/upload/v1742848974/final_with_bg_bw7szt.mov',
	          type: 'video/mp4'
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-237c579ee9f79d4b6e85.js